import { HttpClient, HttpParams, HttpHeaders, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { UtilsService } from './utils.service';


@Injectable({
  providedIn: 'root'
})
export class CrowdtestQuestionnaireService {

  constructor(
    private http: HttpClient,
    private utils: UtilsService
  ) { }
  /**
   * 构建查询参数对象
   * @param queryParams: object形式的查询参数
   */
  parseParams(queryParams: object): HttpParams {
    let params: HttpParams = new HttpParams({});
    Object.entries(queryParams).forEach(([key, value]) => {
      params = params.set(key.toString(), value);
    });
    return params;
  }

  /**
   * 构建http请求的options
   * @param params: 查询参数
   * @param headerParams: 请求头参数
   */
  createOptions(params?: object, headerParams?: object): object {
    let headers = new HttpHeaders({});

    const token = environment.token;
    if (!!token) {
      headers = headers.set('Authorization', `Token ${token}`);
    }

    if (!!headerParams) {
      Object.entries(headerParams).forEach(([key, value]) => {
        headers = headers.set(key.toString(), value);
      });
    }
    const options: object = {
      headers,
      params: !!params ? this.parseParams(params) : undefined,
    };

    return options;
  }

  get(url: string, params?: any, headerParams?: any, noTransKeys?: boolean): Observable<any> {
    const transParams = this.utils.transKeys(params, 'snakeCase');
    return this.http.get(url, this.createOptions(transParams, headerParams)).pipe(
      map(res => {
        if (!noTransKeys) {
          return this.utils.transKeys(res, 'camelCase')
        } else {
          return res
        }
      }),
      catchError(this.basicCatchError)
    );
  }

  post(url: string, data: any, params?: any, headerParams?: any): Observable<any> {
    const transParams = this.utils.transKeys(params, 'snakeCase');
    const transData = this.utils.transKeys(data, 'snakeCase');
    return this.http.post(url, transData, this.createOptions(transParams, headerParams)).pipe(
      map(res => this.utils.transKeys(res, 'camelCase')),
      catchError(this.basicCatchError)
    );
  }

  upload(url: string, data: any, headerParams?: any): Observable<any> {
    const req = new HttpRequest('POST', url, data, { reportProgress: true, ...this.createOptions({}, headerParams) });
    return this.http.request(req);
  }

  put(url: string, data: any, params?: any): Observable<any> {
    const transParams = this.utils.transKeys(params, 'snakeCase');
    const transData = this.utils.transKeys(data, 'snakeCase');
    return this.http.put(url, transData, this.createOptions(transParams)).pipe(
      map(res => this.utils.transKeys(res, 'camelCase')),
      catchError(this.basicCatchError)
    );
  }

  patch(url: string, data: any, params?: any): Observable<any> {
    const transParams = this.utils.transKeys(params, 'snakeCase');
    const transData = this.utils.transKeys(data, 'snakeCase');
    return this.http.patch(url, transData, this.createOptions(transParams)).pipe(
      map(res => this.utils.transKeys(res, 'camelCase')),
      catchError(this.basicCatchError)
    );
  }

  delete(url: string, params?: any): Observable<any> {
    const transParams = this.utils.transKeys(params, 'snakeCase');
    return this.http.delete(url, this.createOptions(transParams)).pipe(
      map(res => this.utils.transKeys(res, 'camelCase')),
      catchError(this.basicCatchError)
    );
  }

  /**
   * 错误捕获函数
   * @param err: http错误响应
   */
  basicCatchError(err: HttpErrorResponse): Observable<any> {
    throw err;
  }
}
